import PrintChecks from './PrintChecks';

export default PrintChecks;
